export class SignUpRequest {
  userName: string;
  password: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  dateTimeOffset: number;

  constructor(
    userName: string,
    password: string,
    fullName: string,
    phoneNumber: string,
    email: string,
    dateTimeOffset: number) {
    this.userName = userName;
    this.password = password;
    this.fullName = fullName;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.dateTimeOffset = dateTimeOffset;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/requests/sign-up-request.ts